import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
export interface RealtimeLegitimationCount {
  IN_PROCESS: number;
  READY_FOR_REVIEW: number;
}
@Injectable({
  providedIn: "root"
})
export class ReviewRealtimeService {
  constructor(private http: HttpClient) {}

  getNumbersOfLegitimations(): Observable<RealtimeLegitimationCount> {
    return this.http.get<RealtimeLegitimationCount>(environment.api.realtimedashboard.overview);
  }
}
